var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148593",
    "data-name": "Rectangle 148593",
    width: 42,
    height: 42,
    transform: "translate(1105 439)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(-1105 -439)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view-2",
    "data-name": "view",
    transform: "translate(1108.202 448.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11724",
    "data-name": "Group 11724",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11723",
    "data-name": "Group 11723",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_37",
    "data-name": "Subtraction 37",
    d: "M8678.845,22242.033c-9.562,0-17.052-10.117-17.366-10.549a.929.929,0,0,1,0-1.1,33.016,33.016,0,0,1,5.221-5.432,25.259,25.259,0,0,1,5.449-3.523,14.92,14.92,0,0,1,13.488.047,25.7,25.7,0,0,1,5.5,3.6,33.3,33.3,0,0,1,5.08,5.314.917.917,0,0,1,0,1.09,33.027,33.027,0,0,1-5.223,5.436,25.435,25.435,0,0,1-5.452,3.525A15.859,15.859,0,0,1,8678.845,22242.033Zm0-20.346c-3.108,0-6.374,1.25-9.708,3.717a32.926,32.926,0,0,0-5.609,5.371l-.135.16.135.162a33.291,33.291,0,0,0,5.621,5.371c3.327,2.467,6.589,3.717,9.7,3.717s6.385-1.25,9.713-3.717a32.774,32.774,0,0,0,5.609-5.371l.134-.162-.134-.156a33.015,33.015,0,0,0-5.621-5.375C8685.218,22222.938,8681.954,22221.688,8678.845,22221.688Z",
    transform: "translate(-8661.049 -22219.594)",
    fill: "#0c0c0b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11726",
    "data-name": "Group 11726",
    transform: "translate(10.757 4.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11725",
    "data-name": "Group 11725",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_38",
    "data-name": "Subtraction 38",
    d: "M8657.333,22229.121a6.79,6.79,0,1,1,6.79-6.789A6.8,6.8,0,0,1,8657.333,22229.121Zm0-11.732a4.945,4.945,0,1,0,4.943,4.943A4.948,4.948,0,0,0,8657.333,22217.389Z",
    transform: "translate(-8650.291 -22215.291)",
    fill: "#0c0c0b"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLarge);
export default __webpack_public_path__ + "static/media/eye-large.e10f2e52.svg";
export { ForwardRef as ReactComponent };